import redo from "@assets/redesign/icons/redo.svg";
import undo from "@assets/redesign/icons/undo.svg";
import Icon from "@components/global/new/Icon/Icon";
import mainLocationsStore from "@mobx/store/locations";
import { MoveType3 } from "@mobx/store/locations/types";
import cn from "classnames";
import { observer } from "mobx-react-lite";
import { SetStateAction } from "react";
import styles from "./Move.module.scss";

export interface IMove3Props {
  setIsDisabled: React.Dispatch<SetStateAction<number>>;
}

const useControl = (props: IMove3Props) => {
  const buildingStore = mainLocationsStore?.activeLocation?.activeBuilding;

  const onMoveTo = async (move: MoveType3) => {
    props.setIsDisabled((v) => v + 1);
    await buildingStore?.move(move);
    setTimeout(() => props.setIsDisabled((v) => v - 1), 200);
  };

  return {
    canUndo: !!buildingStore?.canUndo,
    canRedo: !!buildingStore?.canRedo,

    onMoveTo,
  };
};

const Move3 = observer((props: IMove3Props) => {
  const control = useControl(props);

  return (
    <div className={styles.move_wrapper}>
      <Icon
        src={undo}
        className={cn(styles.move_icon, {
          [styles.disabled]: !control.canUndo,
        })}
        noHover
        onClick={control.onMoveTo.bind({}, "prev")}
      />
      <Icon
        src={redo}
        className={cn(styles.move_icon, {
          [styles.disabled]: !control.canRedo,
        })}
        noHover
        onClick={control.onMoveTo.bind({}, "next")}
      />
    </div>
  );
});

Move3.displayName = "Move3";

export default Move3;